<template>
    <div name="popup">
        <div class="wrapper" v-if="view">
            <img class="img" src="../../assets/popup/popup_2.png" alt="솔닥 서비스 이용 안내"/>
            <div class="sr-only">
                <h2>솔닥 서비스 이용 안내</h2>
                <p>솔닥을 이용해 주셔서 감사합니다. 6월 1일자 비대면 진료 시범사업과 관련한 향후 솔닥 서비스 이용에 대해 안내드립니다. 솔닥은 비대면 질료 시범사업 가이드라인에 맞춰 계도 기간동안 서비스를
                    순차적으로 개편해 나갈 예정이며 변경되는 정책에 대해서는 사전에 공지드리겠습니다.
                </p>
                <p>앞으로도 의료진과 환자 모두에게 신뢰를 주는 올바른 비대면 진료 서비스를 제공하도록 노력하겠습니다. 감사합니다.</p>
            </div>
            <div class="btn-wrapper">
                <a href="https://www.mohw.go.kr/react/al/sal0101vw.jsp?PAR_MENU_ID=04&MENU_ID=040101&page=1&CONT_SEQ=376488" target="_blank" class="text-btn">비대면 진료 시범사업 가이드리안 확인하기</a>
            </div>
            <div class="bottom">
                <span :class="['button', pageButtonClass]" @click="todayClose">오늘 하루 보이지 않음</span>
                <span :class="['button', pageButtonClass]" @click="close">CLOSE</span>
            </div>
        </div>

    </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';

export default {
    name: 'popup',
    data: function()
    {
        return {
            view: false,

        }
    },
    props: {
        pageButtonClass: {
            type: String,
            default: '',
        },
    },
    mounted: function()
    {
        // 쿠키에 데이터 여부 확인
        // today == false 면 보이기
        // today == true 면 today의 유효기간 체크
        // today 의 유효기간(1)이 지났으면 보이기
        // 지나지 않았으면 안보이기
        this.view = cookies.getCookie("today");

        if(this.view == "false")
        {
            this.view = false;
        }
        else
        {
            this.view = true;
        }

    },
    methods: {
        close: function()
        {
            this.view = false;
        },
        todayClose: function()
        {
            this.view = false;
            cookies.setCookie("today", false);
        },
        goSoldocGuide: function()
        {
            window.open('https://www.mohw.go.kr/react/al/sal0101vw.jsp?PAR_MENU_ID=04&MENU_ID=040101&page=1&CONT_SEQ=376488', '_blank');
        },
    }
}
</script>

<style scoped>
    .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 312px;
        position: fixed;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .img{
        width: 100%;
    }
    .bottom{
        height: 28px;
        width: 100%;
        background: #ECF1FF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 20px 0px 20px;
    }
    .button{
        cursor: pointer;
        font-family: 'Pretendard';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 32px;
    }
    .btn-wrapper{
        position: absolute;
        left: 50%;
        bottom: 82px;
        transform: translateX(-50%);
        display: block;
        width: 100%;
        text-align: center;
    }
    .text-btn{
        position: relative;
        font-weight: 600;
        font-size: 15px;
        line-height: 26px;
        color: transparent;
        opacity: 0;
        cursor: pointer;
    }
    .text-btn:after{
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        /* background-color: #00316D; */
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_main/Popup.vue